export const PPE_MANAGEMENT = 'settings-ppe-management'
export const PPE_DETAILS = 'ppe-details'
export const PPE_BASE_URL = 'ppes/'
export const TOOL_MANAGEMENT = 'settings-tool-management'
export const TOOL_DETAILS = 'tool-details'
export const PPE_TYPES = Object.freeze({
  ppe: 0, tool: 1,
})
